import { render, staticRenderFns } from "./MenuMore.vue?vue&type=template&id=086ec11c&scoped=true&"
import script from "./MenuMore.vue?vue&type=script&lang=js&"
export * from "./MenuMore.vue?vue&type=script&lang=js&"
import style0 from "./MenuMore.vue?vue&type=style&index=0&id=086ec11c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ec11c",
  null
  
)

export default component.exports